<template>
    <div class='newList'>
        <div class="bannerDiv">
            <img src="@/assets/images/policy/nav.png" alt="" class="banner" />
            <h2 class="bannerTitle width12">政策资讯</h2>
        </div>
        <el-tabs :tab-position="tabPosition" class="newListTab  main-width">
            <el-tab-pane label="全部">
                <ul class="tabList">
                    <li class="tabListItem">
                        <div class="content">
                            <h3>王凯在视频调度濮阳疫情防控工作时强调坚决果断处置 落实落细措施 用最短时间圈住封死扑灭疫情</h3>
                            <p>3月9日，受省委书记楼阳生委托，省长王凯在北京主持召开视频会议，调度指导濮阳市疫情防控工作，强调要深入贯彻习近平总书记关于疫情防控工作的重要指示，认真落实国务院联防联控机制有关要求和省委疫情防控工作专题会议部署，扛稳扛牢政治责任，</p>
                        </div>
                        <p class="date">03/12<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>深化央地合作 携手共谋新发展工作的通知</h3>
                            <p>3月10日，省政府召开中央驻豫企业座谈会，邀请省电力公司等30家中央驻豫企业负责人探讨深化央地合作，实现新发展。</p>
                        </div>
                        <p class="date">03/12<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>支持中央驻豫科研院所在豫发展凝聚国家创新高地建设强大合力</h3>
                            <p>3月9日，省政府召开中央驻豫科研院所座谈会，邀请中国电子科技集团公司第二十七研究所等37家中央驻豫科研院所负责人共话创新、共谋发展。</p>
                        </div>
                        <p class="date">03/10<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>深化财政体制改革 强化政策支持力度 确保经济平稳健康运行</h3>
                            <p>3月8日，省政府召开县区财政专项工作电视电话会议，安排财政专项工作，部署经济平稳健康运行有关任务。</p>
                        </div>
                        <p class="date">03/08<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>加快推进神农种业实验室建设 为振兴民族种业贡献河南力量</h3>
                            <p>2月24日，神农种业实验室理事会第二次会议在郑州召开。会议听取了神农种业实验室2021年工作情况和2022年重点工作计划汇报，审议了经费预算草案，研究了战略咨询委员会和学术委员会主任人选等事宜。</p>
                        </div>
                        <p class="date">02/24<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>突出规划引领创新驱动 加快循环经济产业发展</h3>
                            <p>2月23日，省委常委、副省长费东斌深入长葛循环经济产业园调研，强调要突出规划引领、创新驱动，强化要素保障，切实破解难题，持续推进循环经济产业发展，为河南在中部地区高质量发展中奋勇争先、更加出彩提供坚实支撑。</p>
                        </div>
                        <p class="date">02/23<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>狠抓政策落地见效 全力帮助市场主体开好局起好步</h3>
                            <p>2月23日，副省长何金平到洛阳市调研“万人助万企”活动和餐饮服务小微企业、个体工商户发展等工作。</p>
                        </div>
                        <p class="date">02/23<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>高质量推进紧密型县域医共体建设</h3>
                            <p>2月18日至19日，副省长戴柏华到周口市调研紧密型县域医共体建设等工作。</p>
                        </div>
                        <p class="date">02/22<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>创新聚能 氢能产业成为我省招商引资新热点</h3>
                            <p>河南省氢能产业起步较早，全省年工业副产氢55万吨，郑州、新乡、濮阳等地初步形成产业集群。去年以来，我省积极实施换道领跑战略，引育并举打造氢能发展生态圈，氢能产业受到越来越多行业龙头企业的关注。</p>
                        </div>
                        <p class="date">03/10<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>省发展改革委副主任支安宇带队赴开封市调研“有诉即办”和优化营商环境工作</h3>
                            <p>3月1日，省发展改革委党组成员、副主任支安宇带队，省政府办公厅职能转变处、省发展改革委营商环境处、省大数据局审批改革协调处、政务服务环境处相关负责同志组成调研组，赴开封市现场调研“有诉即办”“一件事一次办”以及优化营商环境工作落实情况。</p>
                        </div>
                        <p class="date">03/09<span>2022</span></p>
                    </li>
                </ul>
            </el-tab-pane>
            <el-tab-pane label="政策库">
                <ul class="tabList">
                    <li class="tabListItem">
                        <div class="content">
                            <h3>支持中央驻豫科研院所在豫发展凝聚国家创新高地建设强大合力</h3>
                            <p>3月9日，省政府召开中央驻豫科研院所座谈会，邀请中国电子科技集团公司第二十七研究所等37家中央驻豫科研院所负责人共话创新、共谋发展。</p>
                        </div>
                        <p class="date">03/10<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>深化财政体制改革 强化政策支持力度 确保经济平稳健康运行</h3>
                            <p>3月8日，省政府召开县区财政专项工作电视电话会议，安排财政专项工作，部署经济平稳健康运行有关任务。</p>
                        </div>
                        <p class="date">03/08<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>加快推进神农种业实验室建设 为振兴民族种业贡献河南力量</h3>
                            <p>2月24日，神农种业实验室理事会第二次会议在郑州召开。会议听取了神农种业实验室2021年工作情况和2022年重点工作计划汇报，审议了经费预算草案，研究了战略咨询委员会和学术委员会主任人选等事宜。</p>
                        </div>
                        <p class="date">02/24<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>突出规划引领创新驱动 加快循环经济产业发展</h3>
                            <p>2月23日，省委常委、副省长费东斌深入长葛循环经济产业园调研，强调要突出规划引领、创新驱动，强化要素保障，切实破解难题，持续推进循环经济产业发展，为河南在中部地区高质量发展中奋勇争先、更加出彩提供坚实支撑。</p>
                        </div>
                        <p class="date">02/23<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>狠抓政策落地见效 全力帮助市场主体开好局起好步</h3>
                            <p>2月23日，副省长何金平到洛阳市调研“万人助万企”活动和餐饮服务小微企业、个体工商户发展等工作。</p>
                        </div>
                        <p class="date">02/23<span>2022</span></p>
                    </li>
                </ul>
            </el-tab-pane>
            <el-tab-pane label="新闻">
                <ul class="tabList">
                    <li class="tabListItem">
                        <div class="content">
                            <h3>加快推进神农种业实验室建设 为振兴民族种业贡献河南力量</h3>
                            <p>2月24日，神农种业实验室理事会第二次会议在郑州召开。会议听取了神农种业实验室2021年工作情况和2022年重点工作计划汇报，审议了经费预算草案，研究了战略咨询委员会和学术委员会主任人选等事宜。</p>
                        </div>
                        <p class="date">02/24<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>突出规划引领创新驱动 加快循环经济产业发展</h3>
                            <p>2月23日，省委常委、副省长费东斌深入长葛循环经济产业园调研，强调要突出规划引领、创新驱动，强化要素保障，切实破解难题，持续推进循环经济产业发展，为河南在中部地区高质量发展中奋勇争先、更加出彩提供坚实支撑。</p>
                        </div>
                        <p class="date">02/23<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>狠抓政策落地见效 全力帮助市场主体开好局起好步</h3>
                            <p>2月23日，副省长何金平到洛阳市调研“万人助万企”活动和餐饮服务小微企业、个体工商户发展等工作。</p>
                        </div>
                        <p class="date">02/23<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>高质量推进紧密型县域医共体建设</h3>
                            <p>2月18日至19日，副省长戴柏华到周口市调研紧密型县域医共体建设等工作。</p>
                        </div>
                        <p class="date">02/22<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>创新聚能 氢能产业成为我省招商引资新热点</h3>
                            <p>河南省氢能产业起步较早，全省年工业副产氢55万吨，郑州、新乡、濮阳等地初步形成产业集群。去年以来，我省积极实施换道领跑战略，引育并举打造氢能发展生态圈，氢能产业受到越来越多行业龙头企业的关注。</p>
                        </div>
                        <p class="date">03/10<span>2022</span></p>
                    </li>
                    <li class="tabListItem">
                        <div class="content">
                            <h3>省发展改革委副主任支安宇带队赴开封市调研“有诉即办”和优化营商环境工作</h3>
                            <p>3月1日，省发展改革委党组成员、副主任支安宇带队，省政府办公厅职能转变处、省发展改革委营商环境处、省大数据局审批改革协调处、政务服务环境处相关负责同志组成调研组，赴开封市现场调研“有诉即办”“一件事一次办”以及优化营商环境工作落实情况。</p>
                        </div>
                        <p class="date">03/09<span>2022</span></p>
                    </li>
                </ul>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
    export default {
        name: "newList",
        data() {
            return {
                tabPosition: 'left'
            };
        },
        methods: {
            handleClick(){}
        }
    };
</script>
<style lang='scss' scoped>
.newList{
    .bannerDiv{
        position: relative;
        .banner {
            width: 100%;
            height: 134px;
            margin: 10px auto 30px;
        }
        .bannerTitle{
            position: absolute;
            top: 35px;
            left: 170px;
            color: white;
            letter-spacing: 5px;
            font-size: 34px;
            font-style: italic;
            &.width12{

            }
        }
    }
  .newListTab{
      ul,li{ padding:0;margin:0;list-style:none}
      .tabList{
          margin-left: 60px;
          *{
              padding: 0;
              margin: 0;
          }
          .tabListItem{
            border-bottom: 1px solid rgba(229, 229, 229, 1);
            padding: 20px 30px;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            .content{
                color: #505050;
                width: 800px;
                h3{
                    font-size: 17px;
                    line-height: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                }
                p{
                    font-size: 14px;
                    line-height: 18px;
                    word-break: break-all;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
          }
          .date{
              display: block;
              background-color: rgba(244, 250, 253, 1);
              font-size: 22px;
              line-height: 22px;
              height: fit-content;
              padding: 10px;
              box-sizing: border-box;
              align-self: center;
              margin-left: 40px;
              span{
                  display: block;
                  font-size: 18px;
                  line-height: 18px;
                  text-align: center;
                  margin-top: 10px;
              }
          }
      }
  }
}
</style>